import { PaymentModes } from '../../constants';
import checkDoChargeAgencyPlanningFees from './checkDoChargeAgencyPlanningFees';

const checkDoShowMarkupInputs = (tripId) => (store) => {
  const markupInputsEnabled =
    store.user.travelAgency && store.user.travelAgency.doAllowInputMarkupWhenCashPayment;

  if (!markupInputsEnabled) return false;

  const {
    paymentMethods,
    agencyPlanningFees,
    doChargeAgencyPlanningFees,
    selectedTrips,
    tripConfirmation,
  } = store.trip;

  // DON'T SHOW MARKUP INPUT WHEN UPDATING EXISTING TRIP
  if (!selectedTrips || !selectedTrips[tripId] || selectedTrips[tripId].isUpdatingBookedTrip)
    return false;

  // DON'T SHOW MARKUP INPUT ON TRIP CONFIRMATION PAGE
  if (tripConfirmation && tripConfirmation.tripId === tripId) return false;

  const canChargeAgencyPlanningFees = checkDoChargeAgencyPlanningFees(tripId)(store);
  const haveCashPayment =
    paymentMethods &&
    Object.values(paymentMethods ?? {}).find((p) => p.paymentMode === PaymentModes.CASH);

  if (canChargeAgencyPlanningFees && doChargeAgencyPlanningFees && agencyPlanningFees) return false;

  if (!haveCashPayment) return false;

  return true;
};

export default checkDoShowMarkupInputs;
